<div class="layout-content">
  <sub-header>
    <ces-breadcrumb
      [menuItems]="usersPrefBreadcrumbs"
      variation="design"
    ></ces-breadcrumb>
  </sub-header>

  <ces-card
    style="height: calc(100vh - 160px); overflow-y: auto"
    class="card-job-list"
  >
    <ces-card-body>
      <div class="profile-pref-page-container">
        <app-profile-preference-details></app-profile-preference-details>
      </div>
    </ces-card-body>
  </ces-card>
</div>
